import React from 'react';
import CurrencyUtility from '../../../common/utility/CurrencyUtility';
import KaroakeOrderInvoiceView from './KaraokeOrderFormView2InvoicePreviewView';
import KaraokeOrderFormView2CardInput from './KaraokeOrderFormView2CardInput';
import KaraokeOrderFormView2AccountInput from './KaraokeOrderFormView2AccountInput';
import KaraokeOrderPriceInfo from './KaraokeOrderPriceInfo';
import CustomButton from '../../../common/components/CustomButton';
import CustomCheckbox from '../../../common/components/CustomCheckbox';
import CustomRadio from '../../../common/components/CustomRadio';
import KaraokeOrderFormView2MetadataInput from './KaraokeOrderFormView2MetadataInput';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';

type KaraokeOrderFormView2FieldName =
  'royalty_order'|'onvocal'|'physical'|'duet'|'intro_click'|'coupon_code'|
  'title'|'title_kana'|'artist_name'|'artist_name_kana'|
  'lyric_writer_name'|'composer_name'|'applicant_name'|
  'use_vocal_synthesizer'|'vocal_synthesizer_name'|
  'payment_method'|'use_balance'|'agreement'|
  'artist_registration_type'|'artist_registration_mbmail'|'artist_registration_password'|
  'artist_registration_agreement';

export default function KaraokeOrderFormView2({
  getValue,
  setValue,
  getErrors,
  getWarnings,
  balance,
  priceInfo,
  planAmount,
  shouldAcquireCardToken,
  isArtistLoggingIn,
  hasNonAppliedInitialOrderCoupon,
  discountAmount,
  view,
  onBack,
  onNext,
  onCardTokenAcquired,
  onCardTokenError,
} : {
  getValue: (name: KaraokeOrderFormView2FieldName) => string,
  setValue: (name: KaraokeOrderFormView2FieldName, value: string) => void,
  getErrors: (name: KaraokeOrderFormView2FieldName) => FieldValidationErrorsType,
  getWarnings: (name: KaraokeOrderFormView2FieldName) => FieldValidationErrorsType,

  discountAmount: number|null,
  hasNonAppliedInitialOrderCoupon: boolean,
  isArtistLoggingIn: boolean,
  shouldAcquireCardToken: boolean,
  balance: number
  view: string,
  priceInfo: KaraokeOrderPriceInfo,
  planAmount: number,

  onBack: () => void,
  onNext: () => void,
  onCardTokenAcquired: (acquiredCardToken: string) => void,
  onCardTokenError: (message: string) => void,
}) {
  const topRef = React.useRef(null);
  React.useEffect(() => {
    if (view === 'view2') {
      (topRef.current as HTMLElement|null)?.scrollIntoView();
    }
  }, [view]);

  const paymentMethodOptions = [
    {
      value: 'cc_payment',
      view: (
        <div className="radio__wrap">
          <span className="radio__sub">最短で配信！</span>
          <h3 className="radio__header textaline_left">
            <span className="radio__title">
              クレジット
              <br className="sp" />
              カード
            </span>
          </h3>
          <p className="radio__price"><img alt="" src="/img/karaoke_service/credit_logo.png" className="Credit_img" /></p>
        </div>
      ),
    },
    {
      value: 'bank_transfer',
      title: '銀行振込',
    },
  ];

  const contents = (
    <>
      <div className="loader_parts_container" ref={topRef}>
        <form className="cake_ajax_form">
          <KaraokeOrderFormView2MetadataInput
            getValue={getValue}
            setValue={setValue}
            getErrors={getErrors}
          />

          <div className="form page">
            <h2>お支払い</h2>
            <div className="inner">
              <div>
                <KaroakeOrderInvoiceView
                  getValue={getValue}
                  priceInfo={priceInfo}
                  planAmount={planAmount}
                  hasNonAppliedInitialOrderCoupon={hasNonAppliedInitialOrderCoupon}
                  balance={balance}
                  discountAmount={discountAmount}
                />
              </div>
            </div>
          </div>

          <div className="form__body payment_layout">
            <dl>
              <dt>
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label htmlFor="payment">決済方法</label>
              </dt>
              <dd>
                <CustomRadio
                  options={paymentMethodOptions}
                  value={getValue('payment_method')}
                  setValue={(value) => setValue('payment_method', value)}
                  validationErrors={getErrors('payment_method')}
                />
              </dd>
            </dl>

            <KaraokeOrderFormView2CardInput
              visible={getValue('payment_method') === 'cc_payment'}
              shouldAcquireCardToken={shouldAcquireCardToken}
              onCardTokenAcquired={(cardToken) => onCardTokenAcquired(cardToken)}
              onCardTokenError={(message) => onCardTokenError(message)}
            />

            <div className="form__body pc_mb35">
              <dl>
                <dd>
                  <CustomCheckbox
                    checked={getValue('use_balance') === '1'}
                    setChecked={(checked) => setValue('use_balance', checked ? '1' : '0')}
                  >
                    Frekul残高を支払いに使用する
                    {balance !== null && `（現在の残高：${CurrencyUtility.format(balance)}円）`}
                  </CustomCheckbox>
                </dd>
              </dl>
              <dl>
                <dd>
                  <CustomCheckbox
                    checked={getValue('agreement') !== '0'}
                    setChecked={(checked) => setValue('agreement', checked ? '1' : '0')}
                  >
                    <a href="/terms/#karaoke" target="_blank" rel="noopener noreferrer">カラオケ配信利用規約</a>
                    に同意する
                  </CustomCheckbox>
                </dd>
              </dl>
            </div>

            {!isArtistLoggingIn && (
              <KaraokeOrderFormView2AccountInput
                getValue={getValue}
                setValue={setValue}
                getErrors={getErrors}
                getWarnings={getWarnings}
              />
            )}

            <ul className="form_bt">
              <li className="bt">
                <CustomButton type="cancel-split" onClick={() => onBack()}>戻る</CustomButton>
                <CustomButton type="default-split" disabled={!(getValue('agreement') !== '0' && (isArtistLoggingIn || getValue('artist_registration_type') === 'auth' || getValue('artist_registration_agreement') !== '0'))} onClick={() => onNext()}>確認画面へ</CustomButton>
              </li>
            </ul>
          </div>
        </form>
      </div>
    </>
  );
  return (
    <article>
      <section className="form page">
        <div className="inner">
          {contents}
        </div>
      </section>
    </article>
  );
}
